import React from 'react';
import { IResourceIcon, IResourceIconProps } from './ResourceIcon';

export const OasisIcon: IResourceIcon = React.forwardRef<SVGSVGElement, IResourceIconProps>((props, ref) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.0775 18.4625L27.7025 9.71252C27.3166 9.58183 26.8984 9.58183 26.5125 9.71252L2.8875 18.4625C2.19542 18.721 1.74023 19.3863 1.75 20.125V40.25H5.25V22.645L8.75 23.94V40.7225C8.74731 41.1877 8.92992 41.6348 9.2575 41.965L9.2696 41.9763C9.62879 42.3116 14.8814 47.215 28 47.215C40.7265 47.215 46.0502 42.5682 46.685 42.0142L46.6851 42.0141C46.7136 41.9892 46.7327 41.9725 46.7425 41.965C47.0701 41.6348 47.2527 41.1877 47.25 40.7225V23.7825L53.0775 21.7875C53.7957 21.5515 54.2811 20.881 54.2811 20.125C54.2811 19.3691 53.7957 18.6986 53.0775 18.4625ZM27.1426 13.2125L47.1276 20.125L27.1426 27.02L8.54006 20.125L27.1426 13.2125ZM28.0001 43.75C37.4851 43.75 42.2626 40.9675 43.7501 39.9V24.99L27.7026 30.485C27.3167 30.6157 26.8985 30.6157 26.5126 30.485L12.2501 25.235V39.9C13.7201 40.9675 18.5151 43.75 28.0001 43.75Z"
      fill="white"
    />
    <mask
      id="mask0_oasis"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="9"
      width="54"
      height="39"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.0775 18.4625L27.7025 9.71252C27.3166 9.58183 26.8984 9.58183 26.5125 9.71252L2.8875 18.4625C2.19542 18.721 1.74023 19.3863 1.75 20.125V40.25H5.25V22.645L8.75 23.94V40.7225C8.74731 41.1877 8.92992 41.6348 9.2575 41.965L9.2696 41.9763C9.62879 42.3116 14.8814 47.215 28 47.215C40.7265 47.215 46.0502 42.5682 46.685 42.0142L46.6851 42.0141C46.7136 41.9892 46.7327 41.9725 46.7425 41.965C47.0701 41.6348 47.2527 41.1877 47.25 40.7225V23.7825L53.0775 21.7875C53.7957 21.5515 54.2811 20.881 54.2811 20.125C54.2811 19.3691 53.7957 18.6986 53.0775 18.4625ZM27.1426 13.2125L47.1276 20.125L27.1426 27.02L8.54006 20.125L27.1426 13.2125ZM28.0001 43.75C37.4851 43.75 42.2626 40.9675 43.7501 39.9V24.99L27.7026 30.485C27.3167 30.6157 26.8985 30.6157 26.5126 30.485L12.2501 25.235V39.9C13.7201 40.9675 18.5151 43.75 28.0001 43.75Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_oasis)">
      <rect width="56" height="56" fill="white" />
    </g>
  </svg>
));

OasisIcon.displayName = 'OasisIcon';
